
import { 
  Search, 
  ShoppingBag, 
  Download, 
  BarChart3,
  Shield, 
  Clock
} from "lucide-react";

const features = [
  {
    icon: <Search className="h-10 w-10 text-primary" />,
    title: "Find the Perfect Workflow",
    description: "Search and filter through thousands of pre-built workflows to find exactly what you need for your business."
  },
  {
    icon: <ShoppingBag className="h-10 w-10 text-primary" />,
    title: "Sell Your Expertise",
    description: "Turn your automation knowledge into income by selling your custom workflows on our marketplace."
  },
  {
    icon: <Download className="h-10 w-10 text-primary" />,
    title: "Instant Download",
    description: "Purchase and download workflow templates instantly, ready to import into your favorite automation tool."
  },
  {
    icon: <Shield className="h-10 w-10 text-primary" />,
    title: "Vetted Quality",
    description: "All workflows are reviewed to ensure they meet our quality standards and work as described."
  },
  {
    icon: <Clock className="h-10 w-10 text-primary" />,
    title: "Save Hours of Work",
    description: "Skip the learning curve and implement complex automations in minutes instead of days."
  },
  {
    icon: <BarChart3 className="h-10 w-10 text-primary" />,
    title: "Seller Analytics",
    description: "Track performance with detailed analytics on views, downloads, and revenue from your workflows."
  }
];

const FeaturesSection = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Everything You Need to Automate Faster
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Our marketplace streamlines how automation experts share and discover workflows.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-card p-6 rounded-lg border border-border hover-scale">
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
              <p className="text-muted-foreground">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
